import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
} from 'react';

import { EAuth } from '@/config/enums';
import { setCookie, parseCookies } from 'nookies';

interface SimpleMessageContextType {
  selectedOption: any; // Tipo correto para selectedOption
  setSelectedOption: Dispatch<SetStateAction<any>>; // Tipo correto para setSelectedOption
  internalSelectedOption: any;
  setInternalSelectedOption: Dispatch<SetStateAction<any>>;
}

const defaultValue: SimpleMessageContextType = {
  selectedOption: '', // Valor inicial para selectedOption
  setSelectedOption: () => {}, // Função vazia para setSelectedOption
  internalSelectedOption: '',
  setInternalSelectedOption: () => {},
};

interface SendAgentNameContextType {
  sendAgentName: boolean;
  setSendAgentName: (value: boolean) => void;
}

const sendAgentNameDefault: SendAgentNameContextType = {
  sendAgentName: true,
  setSendAgentName: () => {},
};

const SimpleMessageContext = createContext(defaultValue);

const SendAgentNameContext = createContext(sendAgentNameDefault);

interface SimpleMessageProviderProps {
  children: ReactNode;
}

export const useSimpleMessageContext = () => useContext(SimpleMessageContext);
export const useSendAgentNameContext = () => useContext(SendAgentNameContext);

export const SimpleMessageProvider = ({
  children,
}: SimpleMessageProviderProps) => {
  const cookies = parseCookies();

  const [selectedOption, setSelectedOption] = useState<any>('');
  const [sendAgentName, setSendAgentName] = useState<boolean>(true);
  const [internalSelectedOption, setInternalSelectedOption] = useState<any>('');

  const handleSendAgentName = useCallback(
    (value: boolean) => {
      const options = {
        maxAge: 60 * 60 * 24 * 30,
        path: '/',
      };

      const idAgent = cookies[EAuth.ID_AGENTE];
      const idClient = cookies[EAuth.ID_CLIENTE];

      setCookie(
        undefined,
        `${EAuth.SEND_AGENT_NAME_IN_MESSAGE}-${idAgent}-${idClient}`,
        String(value),
        options,
      );

      setSendAgentName(value);
    },
    [cookies],
  );

  useEffect(() => {
    const idAgent = cookies[EAuth.ID_AGENTE];
    const idClient = cookies[EAuth.ID_CLIENTE];

    const isSendAgentName =
      cookies[`${EAuth.SEND_AGENT_NAME_IN_MESSAGE}-${idAgent}-${idClient}`] ===
      undefined
        ? true
        : cookies[
            `${EAuth.SEND_AGENT_NAME_IN_MESSAGE}-${idAgent}-${idClient}`
          ] === 'true';

    setSendAgentName(isSendAgentName);
  }, [cookies]);

  return (
    <SimpleMessageContext.Provider
      value={{
        selectedOption,
        setSelectedOption,
        internalSelectedOption,
        setInternalSelectedOption,
      }}
    >
      <SendAgentNameContext.Provider
        value={{
          sendAgentName,
          setSendAgentName: handleSendAgentName,
        }}
      >
        {children}
      </SendAgentNameContext.Provider>
    </SimpleMessageContext.Provider>
  );
};
